import React, { useState } from 'react';
import styles from './styles/Keys.module.css';

/**
 * The smallest possible "make a key" form, for creating one without leaving the
 * situation or choice being edited. The full form in the Keys panel also
 * handles editing and collaborator queues; this one only ever creates.
 *
 * @param {{
 *   onCreate: (data: {name: string, description: string}) => void,
 *   onCancel: () => void,
 *   submitLabel?: string,
 * }} props
 */
const KeyInlineCreateForm = ({ onCreate, onCancel, submitLabel = 'Create and add' }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');

    const submit = () => {
        if (!name.trim()) {
            setError('Key name is required');
            return;
        }
        onCreate({ name: name.trim(), description });
    };

    return (
        <div className={styles.inlineForm}>
            <label className={styles.inlineLabel}>
                Key name <span className={styles.required}>*</span>
                <input
                    type="text"
                    value={name}
                    onChange={(event) => {
                        setName(event.target.value);
                        if (error) setError('');
                    }}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') submit();
                        if (event.key === 'Escape') onCancel();
                    }}
                    pattern="[A-Za-z0-9 ]+"
                    placeholder="e.g. Rusty key"
                    autoFocus
                />
            </label>
            {error && <span className={styles.error}>{error}</span>}
            <label className={styles.inlineLabel}>
                Description <span className={styles.optional}>(optional, only you see this)</span>
                <textarea
                    rows={2}
                    value={description}
                    onChange={(event) => setDescription(event.target.value)}
                />
            </label>
            <div className={styles.pickerActions}>
                <button type="button" className={styles.primaryButton} onClick={submit}>
                    {submitLabel}
                </button>
                <button type="button" className={styles.secondaryButton} onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </div>
    );
};

export default KeyInlineCreateForm;
